var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { Box, useMediaQuery } from '@mui/material';
import { ActionTabs } from '../..';
var HOVER_BUTTON_STRINGS = appStrings.modules.nugget;
export var HoverButton = function (_a) {
    var isVisible = _a.isVisible, _b = _a.isAbsolutelyPositioned, isAbsolutelyPositioned = _b === void 0 ? true : _b, _c = _a.position, position = _c === void 0 ? 'default' : _c, idPrefix = _a.idPrefix, hasBookmarked = _a.hasBookmarked, handleActionBookmark = _a.handleActionBookmark, handleActionAddTask = _a.handleActionAddTask, handleActionShare = _a.handleActionShare;
    var _d = useState(false), showCopySuccess = _d[0], setShowCopySuccess = _d[1];
    var isMobile = useMediaQuery('(hover: none), (max-width: 900px)');
    var visible = isMobile ? true : isVisible;
    var possibleActions = [];
    if (handleActionBookmark) {
        possibleActions.push({
            id: idPrefix ? "".concat(idPrefix, "-bookmark-btn") : undefined,
            icon: hasBookmarked ? 'BookmarkCheck' : 'Bookmark',
            onClick: handleActionBookmark,
        });
    }
    if (handleActionShare) {
        possibleActions.push({
            id: idPrefix ? "".concat(idPrefix, "-share-btn") : undefined,
            icon: 'Share06',
            onClick: handleActionShare,
            tooltipOnClickText: HOVER_BUTTON_STRINGS.dialogNuggetActions.linkCopied,
            tooltipPosition: 'top',
        });
    }
    if (handleActionAddTask) {
        possibleActions.push({
            id: idPrefix ? "".concat(idPrefix, "-add-task-btn") : undefined,
            icon: 'BookmarkAdd',
            onClick: handleActionAddTask,
        });
    }
    return (_jsx(Box, { sx: hoverButtonSx(visible, isAbsolutelyPositioned, position), children: _jsx(ActionTabs, { actions: possibleActions, showCopySuccess: showCopySuccess, onCopySuccessChange: setShowCopySuccess, borderColor: "Colors/Border/border-primary" }) }));
};
var hoverButtonSx = function (isVisible, isAbsolutelyPositioned, position) {
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign({ transition: 'opacity 0.3s ease-in-out', opacity: isVisible ? 1 : 0 }, (isAbsolutelyPositioned && {
            position: 'absolute',
            top: position === 'flush' ? backrs.spacing['spacing-none'] : backrs.spacing['spacing-xl'],
            right: position === 'flush' ? backrs.spacing['spacing-none'] : backrs.spacing['spacing-2xl'],
            zIndex: 1,
        })));
    };
};
